import { Action } from 'redux'
import User from '../../interfaces/User'
import actions, { LoginUserAction, SetUserAction } from './actions'

export const actionCreators = {
    login: (login: string, password: string) => ({ type: actions.LOGIN, login, password } as LoginUserAction),
    setUser: (user: User) => ({ type: actions.SET_USER, user } as SetUserAction),
    clearUser: () => ({ type: actions.CLEAR_USER } as Action)
}
